import './footer.scss';
export default (() => {});